import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { CanActivate } from '@angular/router';

@Injectable({
   providedIn: 'root'
})
export class AuthGuard implements CanActivate {
    constructor(private auth: AuthService) { }
    
    public canActivate(): Observable<boolean> {
        return this.auth.isAuthenticated().pipe(
            tap(loggedIn => {
                if (!loggedIn) {
                    this.auth.login();
                }
            })
        );
    }
}
